declare namespace $ {

	type $mol_book2__placeholders_shm_hitalama_projects_map_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_book2['placeholders'] >
	>
	type $mol_book2__pages_shm_hitalama_projects_map_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_projects_map['pages'] >
		,
		ReturnType< $mol_book2['pages'] >
	>
	export class $shm_hitalama_projects_map extends $mol_view {
		pages( ): readonly($mol_view)[]
		Book( ): $mol_book2
		projects( ): $shm_hitalama_projects
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=map.view.tree.d.ts.map